import React from 'react';

const AdminDashboard = () => {
    return (
        <div>
            admin dashboard
        </div>
    );
};

export default AdminDashboard;